export enum ReactSelectMenuPosition {
  AUTO = "auto",
  BOTTOM = "bottom",
  TOP = "top"
}
